module.exports = __webpack_public_path__ + "img/location.a5c5bf80.png";